
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import FeedbacksGivenList from '@/components/candidate/FeedbacksGivenList';
import { useIsMobile } from '@/hooks/use-mobile';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ReceivedFeedbacks } from './sections/ReceivedFeedbacks';
import ProjectsTab from '@/components/projects/ProjectsTab';

const CandidatTabs = () => {
  const isMobile = useIsMobile();
  const [feedbacksSubTab, setFeedbacksSubTab] = useState<'received' | 'given'>('received');

  return (
    <Tabs defaultValue="feedbacks" className="w-full">
      <TabsList className={`grid ${isMobile ? 'grid-cols-3 gap-y-2' : 'grid-cols-3'} mb-6 md:mb-8`}>
        <TabsTrigger value="feedbacks" className="text-xs md:text-sm">
          Feedbacks
        </TabsTrigger>
        <TabsTrigger value="analyse" className="text-xs md:text-sm">
          Analyse
        </TabsTrigger>
        <TabsTrigger value="projects" className="text-xs md:text-sm">
          Projets
        </TabsTrigger>
      </TabsList>
      
      <TabsContent value="feedbacks" className="mt-4 md:mt-6">
        <Card>
          <CardHeader className="pb-3">
            <div className="flex justify-between items-center">
              <CardTitle>Mes Feedbacks</CardTitle>
              <div className="flex space-x-2">
                <Button 
                  variant={feedbacksSubTab === 'received' ? 'default' : 'outline'} 
                  size="sm"
                  onClick={() => setFeedbacksSubTab('received')}
                >
                  Reçus
                </Button>
                <Button 
                  variant={feedbacksSubTab === 'given' ? 'default' : 'outline'} 
                  size="sm"
                  onClick={() => setFeedbacksSubTab('given')}
                >
                  Donnés
                </Button>
              </div>
            </div>
          </CardHeader>
          <CardContent>
            {feedbacksSubTab === 'received' ? (
              <ReceivedFeedbacks isCandidat={true} isEntreprise={false} />
            ) : (
              <FeedbacksGivenList />
            )}
          </CardContent>
        </Card>
      </TabsContent>
      
      <TabsContent value="analyse" className="mt-4 md:mt-6">
        <Card>
          <CardHeader>
            <CardTitle>Analyse de performance</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="font-semibold mb-2">Points forts</h3>
                <div className="flex flex-wrap gap-2">
                  <span className="bg-green-100 text-green-800 text-sm px-2 py-1 rounded-full">Communication</span>
                  <span className="bg-green-100 text-green-800 text-sm px-2 py-1 rounded-full">Technique</span>
                  <span className="bg-green-100 text-green-800 text-sm px-2 py-1 rounded-full">Adaptabilité</span>
                </div>
              </div>
              
              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="font-semibold mb-2">Axes d'amélioration</h3>
                <div className="flex flex-wrap gap-2">
                  <span className="bg-orange-100 text-orange-800 text-sm px-2 py-1 rounded-full">Leadership</span>
                  <span className="bg-orange-100 text-orange-800 text-sm px-2 py-1 rounded-full">Prise de décision</span>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </TabsContent>
      
      <TabsContent value="projects" className="mt-4 md:mt-6">
        <ProjectsTab />
      </TabsContent>
    </Tabs>
  );
};

export default CandidatTabs;
